import React from "react";

function Blog(){
return(
<>
{/* <!-- About Section  -->*/}
<div className="blog-area gray-bg section-padding">
        <div className="container">
            <div className="row justify-content-center text-center">
                <div className="col-lg-7">
                    <div className="section-title">
                        <p>Read Our Latest News</p>
                        <h2>Recent Articles</h2>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-4 col-lg-4 col-md-6 wow fadeInUp animated" data-wow-delay="200ms">
                    <div className="blog-wrap">
                        <div className="blog-content">
                            <div className="blog-meta">
                                <div className="blog-date">
                                    <span>Jan 21, 2024</span>
                                </div>
                            </div>
                            <div className="blog-title">
                                <h5>Five Importance logistics solutions for Parcel & Delivery Services </h5>
                            </div>
                            <div className="blog-img-wrap">
                                <div className="blog-img">
                                    <img src="assets/img/blog/1.jpg" alt=""/>
                                </div>
                                <div className="blog-cat">
                                    <a href="#">standard, </a>
                                    <a href="#"> express</a>
                                </div>
                            </div>
                            <div className="blog-desc">
                                <p>There are some reason Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorem, facilis perferendis ipsam.</p>
                            </div>
                            <div className="blog-more">
                                <a href="#" className="main-btn border-btn">Read More <i className="las la-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6 wow fadeInUp animated" data-wow-delay="400ms">
                    <div className="blog-wrap">
                        <div className="blog-content">
                            <div className="blog-meta">
                                <div className="blog-date">
                                    <span>Jan 07, 2024</span>
                                </div>

                            </div>
                            <div className="blog-title">
                                <h5>Cargo Shipment on Ocean Freight Demands Frequently Costly</h5>
                            </div>
                            <div className="blog-img-wrap">
                                <div className="blog-img">
                                    <img src="assets/img/blog/2.jpg" alt=""/>
                                </div>
                                <div className="blog-cat">
                                    <a href="#">standard, </a>
                                    <a href="#"> express</a>
                                </div>
                            </div>
                            <div className="blog-desc">
                                <p>There are some reason Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorem, facilis perferendis ipsam.</p>
                            </div>
                            <div className="blog-more">
                                <a href="#" className="main-btn border-btn">Read More <i className="las la-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6 wow fadeInUp animated" data-wow-delay="600ms">
                    <div className="blog-wrap">
                        <div className="blog-content">
                            <div className="blog-meta">
                                <div className="blog-date">
                                    <span>Dec 16, 2022</span>
                                </div>

                            </div>
                            <div className="blog-title">
                                <h5>We believe in building long lasting our business relationships</h5>
                            </div>
                            <div className="blog-img-wrap">
                                <div className="blog-img">
                                    <img src="assets/img/blog/3.jpg" alt=""/>
                                </div>
                                <div className="blog-cat">
                                    <a href="#">standard, </a>
                                    <a href="#"> express</a>
                                </div>
                            </div>
                            <div className="blog-desc">
                                <p>There are some reason Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorem, facilis perferendis ipsam.</p>
                            </div>
                            <div className="blog-more">
                                <a href="#" className="main-btn border-btn">Read More <i className="las la-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</>

)


}    
export default Blog;